export const sx = {
	margin: '0 10%',
	color: '#444444',
	lineHeight: 1,
	padding: '10px',
	'h1, h2, h3, h4': {
		color: '#111111',
		fontWeight: 400,
	},
	'h1, h2, h3, h4, h5, p': {
		marginBottom: '24px',
		padding: 0,
	},
	h1: {
		fontSize: '48px',
	},
	h2: {
		fontSize: '36px',
		margin: '24px 0 6px',
	},
	h3: {
		fontSize: '24px',
	},
	h4: {
		fontSize: '21px',
	},
	h5: {
		fontSize: '18px',
	},
	a: {
		color: '#0099ff',
		margin: 0,
		padding: 0,
		verticalAlign: 'baseline',
	},
	'ul, ol': {
		padding: 0,
		margin: 0,
	},
	li: {
		lineHeight: '24px',
	},
	'li ul, li ul': {
		marginLeft: '24px',
	},
	'p, ul, ol': {
		fontSize: '16px',
		lineHeight: '24px',
	},
	pre: {
		padding: '0px 24px',
		maxWidth: '60%',
		whiteSpace: 'pre-wrap',
	},
	code: {
		fontFamily: 'Consolas, Monaco, Andale Mono, monospace',
		lineHeight: 1.5,
		fontSize: '13px',
	},
	aside: {
		display: 'block',
		float: 'right',
		width: '390px',
	},
	blockquote: {
		margin: '1em 2em',
		maxWidth: '60%',
	},
	'blockquote p': {
		color: '#666',
		maxWidth: '60%',
	},
	hr: {
		width: '540px',
		textAlign: 'left',
		margin: '0 auto 0 0',
		color: '#999',
	},
	table: {
		borderCollapse: 'collapse',
		margin: '1em 1em',
		border: '1px solid #CCC',
	},
	'table thead': {
		backgroundColor: '#EEE',
	},
	'table thead td': {
		color: '#666',
	},
	'table td': {
		padding: '0.5em 1em',
		border: '1px solid #CCC',
	},
};
